import React from "react"

import {MoveTo_Manager} from "../../model/manager"
import ModalMoveTo_SelectFolder from "./select-folder"

type Props = {
    manager: MoveTo_Manager
}

// const debug = "ModalMoveTo"
const debug = false

export default function ModalMoveTo_Project(props:Props) {

    return (
        <div className="flex-column-top-stretch flex-1 min-h-0">
            <ModalMoveTo_SelectFolder manager={props.manager}/>
        </div>
    )
}